import React, {Component} from "react"
import {RouteComponentProps} from "react-router-dom"

import tracking from "@irati-tracking/wallet/tenantWallet"
import {TenantWalletTransfer} from "@irati/types"
import {hangPromise} from "@irati/utils/promise"
import Loading from "@irati/ui/src/Loading"
import History from "@irati/utils/history"
import topupService from "@irati/wallet/services/TopUp"

import ErrorCard from "./ErrorCard"
import CardConfirmationPopUp from "./CardConfirmationPopUp"

interface Match {
  tenantWalletTopupId: string
}

interface Props extends RouteComponentProps<Match> {}

interface State {
  isError: boolean,
  showCompletionModal: boolean,
  load: Promise<any>,
  tenantWalletTopup?: TenantWalletTransfer
}

class ConfirmTenantWalletTopUpPage extends Component<Props, State> {
  state: State = {
    isError: false,
    showCompletionModal: false,
    load: hangPromise()
  }

  componentDidMount() {
    const {tenantWalletTopupId} = this.props.match.params
    const load = topupService.complete(tenantWalletTopupId).then((topUp) => {
      tracking.completeTenantWalletTopUp()
      this.setState({showCompletionModal: true, tenantWalletTopup: topUp})
    }).catch(() => {
      this.setState({isError: true})
    })
    this.setState({load})
  }

  goBackToTransactions = () => {
    History.push({
      pathname: "/wallet/tenant"
    })
  }

  handleTryAgain = () => {
    const {tenantWalletTopup} = this.state
    History.push({
      pathname: "/wallet/tenant/top-up",
      tenantWalletTopup
    })
  }

  render() {
    const {isError, showCompletionModal, tenantWalletTopup, load} = this.state

    if (isError) {
      return <ErrorCard goBackToTransactions={this.goBackToTransactions} handleTryAgain={this.handleTryAgain} />
    }

    if (showCompletionModal) {
      return (
        <CardConfirmationPopUp
          tenantWalletTopup={tenantWalletTopup}
          goBackToTransactions={this.goBackToTransactions}
          showCompletionModal={showCompletionModal} />
      )
    }

    return (
      <Loading load={load} />
    )
  }
}

export default ConfirmTenantWalletTopUpPage
